import { Alert } from '../ui/Badge';
import { RegisterCtaButton } from './RegisterCta';
import './demo-banner.css';

export function DemoBanner() {
  return (
    <Alert tone="info">
      <div className="demo-banner">
        <div>
          <strong>Cuenta de demostración</strong>
          <p className="demo-banner__text">
            Estás viendo informes y licencias con datos ficticios. Crea tu cuenta para gestionar tu
            negocio real.
          </p>
        </div>
        <RegisterCtaButton size="sm" variant="secondary">
          Crear cuenta real
        </RegisterCtaButton>
      </div>
    </Alert>
  );
}
